import React, {useEffect} from 'react'
import { Link } from "gatsby"
import featureCalloutStyle from "../components/css/featureCalloutStyle.module.scss"
import HorizontalScroller from '../components/libs/HorizontalScroller'
import HighlightLink from '../components/highlightLink'
import '../components/css/global.scss'
import latestNewsStyle from "../components/css/latestNewsStyle.module.scss"


export default function({id, slides, highlightText, morelink}){
   
    let oHorSlide;
    let slideController;

    useEffect(function(){
        oHorSlide = new HorizontalScroller(document.getElementById(id));
        
        /* this is just dealing with the controller of the slide show */
        slideController = document.getElementById(id).querySelector(".slidecontrol");
        slideController.querySelector(".bar").style.width = (oHorSlide.currentSlideNum/oHorSlide.numberOfSlides*100) + "%"
        slideController.querySelector(".numSlides").innerHTML = "0"+oHorSlide.numberOfSlides;

        if(oHorSlide.numberOfSlides===0)
        {
            slideController.style.display = "none";
        }
    }, []);

    const nextSlide = function(){
        oHorSlide.nextSlide();
        console.log(oHorSlide)
        slideController.querySelector(".bar").style.width = (oHorSlide.currentSlideNum/oHorSlide.numberOfSlides*100) + "%"
    }

    const prevSlide = function(){
        oHorSlide.prevSlide();
        console.log(oHorSlide)
        slideController.querySelector(".bar").style.width = (oHorSlide.currentSlideNum/oHorSlide.numberOfSlides*100) + "%"
    }

    return (
        <section className={latestNewsStyle.content}>
            <h2 className={latestNewsStyle.calloutHighlightHeader}>{highlightText}</h2>
            
            <article id={id} className={"horscroll "+featureCalloutStyle.slideshow}>
                <div className={"keyhole "+featureCalloutStyle.keyhole}>
                    <div className={"strip "+featureCalloutStyle.slidestrip}>
                        {
                            slides.map(slide=> 
                                <article className={"slide "+latestNewsStyle.slide} style={{backgroundImage: 'url(http://api.vanarts.com/assets/'+slide.image+')'}}>
                                    <Link to="/">{slide.title}</Link>
                                </article>
                            )
                        }
                    </div>
                </div>
                <div className={"slidecontrol "+featureCalloutStyle.slideControl}>
                    <button className={featureCalloutStyle.arrowLeft} onClick={e=>prevSlide()}></button>
                    <span>01</span>
                    <div className={featureCalloutStyle.progress}>
                        <div className={"bar "+featureCalloutStyle.bar}></div>
                    </div>
                    <span className="numSlides"></span>
                    <button className={featureCalloutStyle.arrowRight} onClick={e=>nextSlide()}></button>
                </div>
            </article>
            {
                morelink && 
                <div className="content">
                    <HighlightLink theme="dark" label="CHECKOUT MORE NEWS"/>
                </div>
            }
            
        </section>
    )
}